import styled from "@emotion/styled";
import { Stack, Typography } from "@mui/material";
import FlowImage from "assets/images/flow.png";

const Flow = styled.img`
  width: 900px;
  object-fit: contain;
`;

export const Welcome = () => {
  return (
    <>
      <Stack direction="column" alignItems="center" spacing={2}>
        <Typography variant="h5" fontWeight={700}>
          Welcome to Finance!
        </Typography>
        <Typography variant="caption">
          Follow these steps to get started
        </Typography>
      </Stack>
      <Flow src={FlowImage} alt="Flow Image" />
    </>
  );
};
